// extracted by mini-css-extract-plugin
export default {"menu":"mPEnHw","menuItem":"MUPvh2","subMenu":"M4eMKq","arrow":"VgEFyk","menuHeading":"wfn2Xc","subMenuItem":"AJX9Dt","link":"x2gIha"};